import { render, staticRenderFns } from "./WorkersHorizontalList.vue?vue&type=template&id=70a1b221&"
import script from "./WorkersHorizontalList.vue?vue&type=script&lang=ts&"
export * from "./WorkersHorizontalList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockHorizontalList: require('/tmp/build_dc55b0b5/src/components/block/HorizontalList.vue').default})
